/**
 * PremierPartnerGroupForm
 * state of component rendered within container
 * @param newState new form state, passed when resetting state to maintain state as instance of this class
 */
export default class PremierPartnerGroupForm {
	constructor(newState) {
		this.premierPartnerGroup = newState
			? newState.premierPartnerGroup
			: null;
		this.requiresSubgroupOrSiteAccess = newState
			? newState.requiresSubgroupOrSiteAccess
			: 'No';
		this.subgroups = newState ? newState.subgroups : [];
		this.sites = newState ? newState.sites : [];
	}

	/**
	 *
	 * @param {*} touchedFields array of strings, each representing  field of the PremierPartnerGroupForm object
	 * @returns array of PremierPartnerGroupFormValidationError objects
	 */
	Validate(touchedFields) {
		let validationResult = [];

		//validate premierPartnerGroup
		if (
			(this.premierPartnerGroup === null ||
				this.premierPartnerGroup === '') &&
			touchedFields.includes('premierPartnerGroup')
		) {
			let error = new PremierPartnerGroupFormValidationError();
			error.errorMessage = 'Premier Partner Group is required';
			error.fieldName = 'premierPartnerGroup';
			validationResult.push(error);
		}

		return validationResult;
	}
}

export class PremierPartnerGroupFormValidationError {
	constructor() {
		this.fieldName = null;
		this.errorMessage = null;
	}
}
